import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_authDomain,
  databaseURL: process.env.REACT_APP_FIREBASE_databaseURL,
  projectId: process.env.REACT_APP_FIREBASE_projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
  apiSupportStorageBucket:
    process.env.REACT_APP_FIREBASE_apiSupportStorageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_appId,
  measurementId: process.env.REACT_APP_FIREBASE_measurementId,
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

export const apiSupportStorage = firebase
  .app()
  .storage(`gs://${firebaseConfig.apiSupportStorageBucket}`);

export const authProviders = [firebase.auth.EmailAuthProvider.PROVIDER_ID];
